"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Icon;
(function (Icon) {
    Icon["AngleDown"] = "angle-down";
    Icon["AngleUp"] = "angle-up";
    Icon["Clear"] = "times";
    Icon["Loading"] = "spinner-third";
    Icon["MinusSquare"] = "minus-square";
    Icon["PlusSquare"] = "plus-square";
    Icon["Search"] = "search";
    Icon["VerticalEllipsis"] = "ellipsis-v";
})(Icon = exports.Icon || (exports.Icon = {}));
//# sourceMappingURL=icon.types.js.map